import React, { useState } from 'react';
import './Login.css';
import customersImage from '../../images/customers.png';
import { Button, Form, Modal } from 'react-bootstrap';
import { adminLogin } from '../../service/adminService';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const [smShow, setSmShow] = useState(false);
    const handleClose = () => setSmShow(false);
    const handleShow = () => setSmShow(true);
    const [isLoading, setIsLoading] = useState(false);
    const [password, setPassword] = useState("");
    let navigate = useNavigate();


    const submitHandler = async (event) => {
        event.preventDefault();
        try {

            setIsLoading(true);
            const { status, data } = await adminLogin(password);
            if (status === 201) {
                if(data.person === 'Unauthorized!'){
                    toast.error('wrong password!')
                    setIsLoading(false);
                    handleClose();
                }
                else if(data.person === 'Mahdi'){
                    toast.success('سام و علیک حاج مهدی');
                    navigate("/dashboard", {  state: {person: data.person }  });
                }
                else if(data.person === 'Azim'){
                    toast.success('چطوری عظیم ؟!');
                    navigate("/dashboard", {  state: {person: data.person } });
                }
            }

        } catch (err) {
           
        }
        setIsLoading(false)
    };
    return (
        <div className='application-layer'>
            <div>
                <section>
                    <div className='button-customer' onClick={handleShow}>
                        <img src={customersImage} alt="" />
                        <span>customers</span>
                    </div>
                </section>
                <Modal
                    size="sm"
                    show={smShow}
                    onHide={handleClose}
                    aria-labelledby="example-modal-sizes-title-sm"
                    backdrop="static"
                >
                    <Modal.Header>
                        <Modal.Title id="example-modal-sizes-title-sm">
                            Customers
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={submitHandler}>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    autoFocus
                                    onChange={e => setPassword(e.target.value)}
                                />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose} disabled={isLoading}>
                            Close
                        </Button>
                        <Button variant="success" onClick={submitHandler} disabled={isLoading || !password}>
                            Submit
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    );
}

export default Login;